// extracted by mini-css-extract-plugin
export default {"shift":"shiftAssignment_shift__oBpdF","shiftSelectionCancelBtn":"shiftAssignment_shiftSelectionCancelBtn__uEoJs"};